var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "DxDataGrid",
        {
          ref: _vm.gridSuperiorRefKey,
          attrs: {
            id: "gridSuperior",
            "data-source": _vm.propostas.produtos,
            "column-auto-width": false,
            "show-borders": true,
            "row-alternation-enabled": true,
          },
          on: { "file-saving": _vm.onFileSavingGridSuperior },
        },
        [
          _c("DxExport", { attrs: { enabled: true } }),
          _vm._v(" "),
          _c("DxColumnFixing", { attrs: { enabled: true } }),
          _vm._v(" "),
          _c(
            "DxColumn",
            {
              attrs: {
                fixed: true,
                visible: true,
                caption: "Itens cotados",
                alignment: "center",
              },
            },
            [
              _c("DxColumn", {
                attrs: {
                  width: 25,
                  "allow-sorting": false,
                  visible: false,
                  "data-field": "informacaoFinanceira",
                  caption: "",
                  alignment: "center",
                },
              }),
              _vm._v(" "),
              _c("DxColumn", {
                attrs: {
                  width: 105,
                  "data-field": "codigoReferencia",
                  caption: "Cód referência",
                },
              }),
              _vm._v(" "),
              _c("DxColumn", {
                attrs: {
                  width: 210,
                  "data-field": "descricao",
                  caption: "Produto",
                },
              }),
              _vm._v(" "),
              _c("DxColumn", {
                attrs: {
                  width: 70,
                  "data-field": "variacao",
                  caption: "Variação",
                },
              }),
              _vm._v(" "),
              _c("DxColumn", {
                attrs: {
                  width: 85,
                  alignment: "right",
                  "data-field": "valorUnitarioSolicitado",
                  caption: "Vlr unit req",
                },
              }),
              _vm._v(" "),
              _c("DxColumn", {
                attrs: {
                  width: 50,
                  alignment: "right",
                  "data-field": "quantidade",
                  caption: "Qtd",
                },
              }),
              _vm._v(" "),
              _c("DxColumn", {
                attrs: {
                  width: 45,
                  "data-field": "unidade",
                  caption: "UN",
                  alignment: "center",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "DxColumn",
            {
              attrs: {
                alignment: "center",
                caption: _vm.buscaNomeFornecedor(0),
              },
            },
            [
              _c("DxColumn", {
                attrs: {
                  width: 65,
                  alignment: "right",
                  caption: "R$ Unit.",
                  "data-field": "FornA_valorUnitario",
                  format: "fixedPoint",
                },
              }),
              _vm._v(" "),
              _c("DxColumn", {
                attrs: {
                  width: 80,
                  alignment: "right",
                  caption: "R$ Total",
                  "data-field": "FornA_valorTotal",
                  format: "fixedPoint",
                },
              }),
              _vm._v(" "),
              _c("DxColumn", {
                attrs: {
                  width: 55,
                  alignment: "right",
                  caption: "%",
                  "data-field": "FornA_percentualUnitarioEmRelacaoValorTotal",
                  format: "fixedPoint",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "DxColumn",
            {
              attrs: {
                alignment: "center",
                caption: _vm.buscaNomeFornecedor(1),
              },
            },
            [
              _c("DxColumn", {
                attrs: {
                  width: 65,
                  alignment: "right",
                  caption: "R$ Unit.",
                  "data-field": "FornB_valorUnitario",
                  format: "fixedPoint",
                },
              }),
              _vm._v(" "),
              _c("DxColumn", {
                attrs: {
                  width: 80,
                  alignment: "right",
                  caption: "R$ Total",
                  "data-field": "FornB_valorTotal",
                  format: "fixedPoint",
                },
              }),
              _vm._v(" "),
              _c("DxColumn", {
                attrs: {
                  width: 55,
                  alignment: "right",
                  caption: "%",
                  "data-field": "FornB_percentualUnitarioEmRelacaoValorTotal",
                  format: "fixedPoint",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "DxColumn",
            {
              attrs: {
                alignment: "center",
                visible: _vm.exibeColuna(),
                caption: _vm.buscaNomeFornecedor(2),
              },
            },
            [
              _c("DxColumn", {
                attrs: {
                  width: 65,
                  alignment: "right",
                  caption: "R$ Unit.",
                  "data-field": "FornC_valorUnitario",
                  format: "fixedPoint",
                },
              }),
              _vm._v(" "),
              _c("DxColumn", {
                attrs: {
                  width: 80,
                  alignment: "right",
                  caption: "R$ Total",
                  "data-field": "FornC_valorTotal",
                  format: "fixedPoint",
                },
              }),
              _vm._v(" "),
              _c("DxColumn", {
                attrs: {
                  width: 55,
                  alignment: "right",
                  caption: "%",
                  "data-field": "FornC_percentualUnitarioEmRelacaoValorTotal",
                  format: "fixedPoint",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { attrs: { id: "gridInferior" } },
        [
          _c(
            "DxDataGrid",
            {
              ref: _vm.gridInferiorRefKey,
              attrs: {
                id: "gridInferior",
                "data-source": _vm.propostas.totalizadores,
                "column-auto-width": false,
                "allow-column-reordering": false,
                "show-borders": true,
                "row-alternation-enabled": true,
              },
              on: { "file-saving": _vm.onFileSavingGridInferior },
            },
            [
              _c("DxColumn", {
                attrs: {
                  width: 565,
                  "allow-sorting": false,
                  fixed: true,
                  alignment: "right",
                  caption: "",
                  "data-field": "colunaTitulo",
                },
              }),
              _vm._v(" "),
              _c("DxColumn", {
                attrs: {
                  width: 200,
                  "allow-sorting": false,
                  caption: _vm.buscaNomeFornecedor(0),
                  alignment: "right",
                  "data-field": "colunaFornecedorA",
                },
              }),
              _vm._v(" "),
              _c("DxColumn", {
                attrs: {
                  width: 200,
                  "allow-sorting": false,
                  caption: _vm.buscaNomeFornecedor(1),
                  alignment: "right",
                  "data-field": "colunaFornecedorB",
                },
              }),
              _vm._v(" "),
              _c("DxColumn", {
                attrs: {
                  width: 200,
                  "allow-sorting": false,
                  caption: _vm.buscaNomeFornecedor(2),
                  visible: _vm.exibeColuna(),
                  alignment: "right",
                  "data-field": "colunaFornecedorC",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }